export default __webpack_public_path__ + "static/media/emerge_logo_inverted.7dd71b16.jpg";